import { jsx } from "react/jsx-runtime";
import "@volue/stitches-core";
import stitches from "../theme.config.es.js";
import { responsiveProps } from "../../utils/responsiveProps.es.js";
import { domProps } from "../../utils/domProps.es.js";
const descendants = "& > *";
const generateColumns = (length) => {
  return Array.from({ length }).map((_next, i) => {
    const numOfCols = i + 1;
    return {
      layout: "tile",
      columns: numOfCols,
      css: {
        [descendants]: {
          flexBasis: numOfCols === 1 ? "100%" : `calc(100% / ${numOfCols} - $layout-gap / calc(${numOfCols} / ${i}))`
        }
      }
    };
  });
};
const box = stitches.css({ display: "flex" });
const styles = stitches.css({
  display: "flex",
  gap: "$layout-gap",
  flexGrow: 1,
  alignItems: "center",
  variants: {
    layout: {
      basic: {
        justifyContent: "flex-start"
      },
      right: {
        justifyContent: "flex-end"
      },
      equal: {
        [descendants]: {
          flexBasis: 0,
          flexGrow: 1
        }
      },
      split: {
        justifyContent: "space-between"
      },
      stack: {
        alignItems: "stretch",
        flexDirection: "column",
        width: "$full"
      },
      tile: {
        flexWrap: "wrap",
        alignItems: "stretch",
        flexBasis: 0,
        [descendants]: {
          flexGrow: 0
        }
      },
      cluster: {
        flexWrap: "wrap"
      }
    },
    alignY: {
      top: { alignItems: "flex-start" },
      center: { alignItems: "center" },
      bottom: { alignItems: "flex-end" },
      stretch: { alignItems: "stretch" }
    },
    alignX: { left: {}, center: {}, right: {}, stretch: {} },
    columns: {}
  },
  compoundVariants: [
    { layout: "basic", css: { justifyContent: "flex-start" } },
    { layout: "right", css: { justifyContent: "flex-end" } },
    { layout: "equal", css: { justifyContent: "normal" } },
    { layout: "split", css: { justifyContent: "space-between" } },
    { layout: "tile", css: { justifyContent: "normal" } },
    { layout: "stack", alignX: "left", css: { alignItems: "flex-start" } },
    { layout: "stack", alignX: "center", css: { alignItems: "center" } },
    { layout: "stack", alignX: "right", css: { alignItems: "flex-end" } },
    { layout: "stack", alignX: "stretch", css: { alignItems: "stretch" } },
    { layout: "cluster", alignX: "left", css: { justifyContent: "flex-start" } },
    { layout: "cluster", alignX: "center", css: { justifyContent: "center" } },
    { layout: "cluster", alignX: "right", css: { justifyContent: "flex-end" } },
    ...generateColumns(32)
  ]
});
const EzLayout = ({
  children,
  className,
  layout = "basic",
  ...initialProps
}) => {
  const props = responsiveProps(
    { ...initialProps, layout },
    true,
    "layout",
    "alignX",
    "alignY",
    "columns"
  );
  return /* @__PURE__ */ jsx("div", { ...domProps({ ...props, className }, box()), children: /* @__PURE__ */ jsx("div", { className: styles(props), children }) });
};
export {
  EzLayout as default
};
//# sourceMappingURL=EzLayout.es.js.map
